import { Button, InputAdornment, TextField } from '@mui/material';
import { textFieldProps } from '../textFieldProps';
import type { FieldComponentProps, FieldTypeSpec } from '../types';

export interface SecretConfig {
  /** A value is already stored on the server (it is never sent back). */
  isSet?: boolean;
}

/**
 * Write-only: `undefined` keeps what the server holds, a string replaces it,
 * '' clears it. The stored value is never shown — only whether one exists.
 */
export function SecretInput({ field, value, onChange, onBlur, error }: FieldComponentProps<string | undefined, SecretConfig>) {
  const { isSet } = field.config;
  const base = textFieldProps(field, error);
  const status = value === ''
    ? 'Will be cleared when you save.'
    : isSet && value === undefined ? 'Saved. Type a new value to replace it.' : undefined;
  return (
    <TextField {...base} type="password" autoComplete="new-password" value={value ?? ''} onBlur={onBlur}
               placeholder={isSet && value === undefined ? '••••••••' : field.placeholder}
               helperText={error ?? status ?? field.helperText}
               onChange={(e) => onChange(e.target.value === '' ? undefined : e.target.value)}
               slotProps={{
                 ...base.slotProps,
                 input: isSet ? {
                   endAdornment: (
                     <InputAdornment position="end">
                       <Button size="small" disabled={field.disabled} onClick={() => onChange(value === '' ? undefined : '')}>
                         {value === '' ? 'Keep' : 'Clear'}
                       </Button>
                     </InputAdornment>
                   ),
                 } : undefined,
               }} />
  );
}

export const secretTypes: Record<string, FieldTypeSpec> = {
  secret: { component: SecretInput, display: () => '••••••••' },
};
